<div class="row h-100 w-100" style="position:absolute;">
	<div style="display: flex;" class="offset-1 col-10 offset-lg-2 col-lg-8 align-items-center text-center">
		<div><h2 [innerHTML]="errorMessage"></h2></div>
	</div>
</div>
